// Responses for /api/content/header and /api/content/footer
export const headerLinks = [
    { name: "Home", url: "/", subLinks: null },
    { name: "Private Jets", url: "/fly/private-jets", subLinks: null },
    { name: "Helicopters", url: "/fly/helicopters", subLinks: null },
    { name: "Group Charter", url: "/fly/group-charter", subLinks: null },
    { name: "Blog", url: "/blog", subLinks: null },
    { name: "SHY Ambassador", url: "/ambassador", subLinks: null },
    { name: "Careers", url: "/careers", subLinks: null },
];

export const footerLinks = [
    { name: "Private Jets", url: "/fly/private-jets", subLinks: null },
    { name: "Helicopters", url: "/fly/helicopters", subLinks: null },
    { name: "Group Charter", url: "/fly/group-charter", subLinks: null },
    { name: "SHY Ambassador", url: "/ambassador", subLinks: null },
    { name: "Careers", url: "/careers", subLinks: null },
    { name: "SHY Aviation Brochure", url: "https://bit.ly/SHY-Aviation-Brochure", subLinks: null },
];
